/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_AviationInputs */

const en_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviation`)
};

const es_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviación`)
};

const fr_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviation`)
};

const de_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luftfahrt`)
};

const ja_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`航空機`)
};

const zh_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`航空`)
};

const ar_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طيران`)
};

const id_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penerbangan`)
};

const it_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviazione`)
};

const ru_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Авиация`)
};

const pt_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviação`)
};

const ko_listing_category_aviation = /** @type {(inputs: Listing_Category_AviationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`항공`)
};

/**
* | output |
* | --- |
* | "Aviation" |
*
* @param {Listing_Category_AviationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_aviation = /** @type {((inputs?: Listing_Category_AviationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_AviationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_aviation(inputs)
	if (locale === "es") return es_listing_category_aviation(inputs)
	if (locale === "fr") return fr_listing_category_aviation(inputs)
	if (locale === "de") return de_listing_category_aviation(inputs)
	if (locale === "ja") return ja_listing_category_aviation(inputs)
	if (locale === "zh") return zh_listing_category_aviation(inputs)
	if (locale === "ar") return ar_listing_category_aviation(inputs)
	if (locale === "id") return id_listing_category_aviation(inputs)
	if (locale === "it") return it_listing_category_aviation(inputs)
	if (locale === "ru") return ru_listing_category_aviation(inputs)
	if (locale === "pt") return pt_listing_category_aviation(inputs)
	return ko_listing_category_aviation(inputs)
});